import { IconProps } from '.';

const PlayButtonIcon = ({ color, customClasses }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 376 376"
      fill="none"
      className={customClasses}
    >
      <circle cx="188" cy="188" r="87" stroke={color || '#ebece9'} />
      <path
        d="M175.023 170.754C175.023 166.879 179.239 164.477 182.572 166.453L211.86 183.814C215.127 185.751 215.127 190.48 211.86 192.416L182.572 209.778C179.239 211.753 175.023 209.351 175.023 205.477L175.023 170.754Z"
        fill={color || '#ebece9'}
      />
    </svg>
  );
};

export default PlayButtonIcon;
